module.exports = __webpack_public_path__ + "static/img/lock_icon.7b31db1d.png";